import Vue from 'vue';
import axios from 'axios';
import '../../../../filters';
import moment from 'moment';
import users from '../../../../users';
import { validationMixin } from 'vuelidate'
import { required, integer, minValue, numeric } from 'vuelidate/lib/validators';

export default {
  name: 'issueDebitCreditNote',
  mixins: [users, validationMixin],
  components: {
    DataGridComp: require('../../../../customcontrols/datagrid.vue').default,
  },
  validations: {
    inputDetails: {
      amount: {
        required,
        minValue: minValue(0.01)
      },
      discountPercentage: {
        minValue: minValue(0)
      }
    }
  },
  props: ['dataObj'],
  data: function () {
    return {
      appId: -1,
      lang: '',
      currentTab: 'tab-details',
      appData: {
        details: [],  
        note: [],
        totalCredit: 0,
        totalDebit: 0
      },

      selectedNoteIndex: -1,
      allowEdit: true,
      deleteConfirmMessage: '',
      newTransDialog: false,
      effectiveDate2: null,
      rdChequeDate2: null,
      confirmRemoveNote: false,
      editNote: {},

      inputDetails: {
        documentType: '',
        charge: '',
        selection: '',
        isOwner: false,
        ageing: 0,
        customerKey: '',
        customerName: '',
        effectiveDate: new Date(),
        amount: 0,
        discountPercentage: 0,
        rdChequeDate: null,
        rdChequeNumber: '',
        consumption: 0,
        description: ''
      },

      chargesDef: [],
      showNoteDialog: false,
      installmentDescribe: '',
      selectedTransactionType: '',
    }
  },
  computed: {
    selectedNote: function () {
      if (this.selectedNoteIndex <= -1)
        return '';

      return this.dataObj.appData.details[this.selectedNoteIndex].documentType;
    },
  },
  watch: {
    selectedNoteIndex: function (value) {
      this.effectiveDate2 = moment(this.dataObj.appData.details[this.selectedNoteIndex].effectiveDate).format('DD/MM/YYYY');
      this.rdChequeDate2 = moment(this.dataObj.appData.details[this.selectedNoteIndex].rdChequeDate).format('DD/MM/YYYY');
      this.selectedTransactionType = this.dataObj.appData.details[this.selectedNoteIndex].code + '/' + this.dataObj.appData.details[this.selectedNoteIndex].subCode;
    },
    selectedTransactionType: function (value) {
      this.dataObj.appData.details[this.selectedNoteIndex].code = +value.split('/')[0];
      this.dataObj.appData.details[this.selectedNoteIndex].subCode = +value.split('/')[1];
    },
    selectedNote: function (value) {
      const trans = this.charges.filter(a => a.documentType == this.dataObj.appData.details[this.selectedNoteIndex].documentType)[0].charges;

      if (trans.length > 0)
        this.selectedTransactionType = trans[0].charge;
      else
        this.selectedTransactionType = null;
    }
  },
  created() {
    this.$material.locale.dateFormat = 'dd/MM/yyyy';
    this.$root.$on('issue_debit_credit_note_updated', this.init);
    this.init();
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        console.log(this.dataObj);
        this.appId = this.dataObj.appId;
        this.charges = this.dataObj.charges;
        this.selectedNoteIndex = 0;
        
        this.fillInputDetails();

        if (this.dataObj.appData.notes.length == 1 && this.dataObj.appData.details[0].amount == 0)
          this.allowEditNote(this.selectedNoteIndex);
      });
    },
    getValidationClass(obj, fieldName) {
      const field = this.$v[obj][fieldName];

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },
    fillAppData(data) {
      this.selectedNoteIndex = data.note[0].sequence;
      this.dataObj.appData.details = data.details;
      this.dataObj.appData.notes = data.notes;
      this.totalCredit = data.totalCredit;
      this.totalDebit = data.totalDebit;
    },
    selectNote(info) {
      if ((info === null) || (info === undefined))
        return;
    },
    addNote() {
      var parameter = {
        ApplicationId: this.appId,
        ApplicationKey: 0
      };

      //let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/IssueDebitCreditNoteActivity/AddNote', parameter)
        .then(response => {
          console.log(response);
          if (response.status == 200) {

            this.dataObj.appData = response.data.item;
            //var maxSeq = response.data.item.note.reduce((max, p) => p.sequence > max ? p.sequence : max, response.data.item.note[0].sequence);
            //this.selectedNoteIndex = response.data.item.note.indexOf(response.data.item.note.filter(a => a.sequence == maxSeq)[0]);

            this.selectedNoteIndex = response.data.item.notes.length - 1;

            //loader.hide();

            this.allowEditNote(this.selectedNoteIndex);
          }
          else {
            //loader.hide();
          }
        })
        .catch(error => {
          console.log(error);
          this.$alertMsg(error);
          //loader.hide();
        });
    },
    fillDocTypeCharges(docType) {
      if (this.selectedNoteIndex <= 0)
        return;

      var parameter = {
        ApplicationId: this.appId,
        ApplicationKey: 0,
        Sequence: this.selectedNoteIndex,
        DocumentType: this.dataObj.appData.details[this.selectedNoteIndex].documentType
      };
      axios.post('/IssueDebitCreditNoteActivity/GetNoteCharges', parameter)
        .then(response => {
          if (response.status == 200) {
            this.dataObj.appData.details[this.selectedNoteIndex].charges = response.data.charges;
            this.dataObj.appData.details[this.selectedNoteIndex].charge = response.data.charges.length > 0 ? response.data.charges[0].value : '';
            this.documentTypesCharges.filter(a => a.docType == this.dataObj.appData.details[this.selectedNoteIndex].documentType)[0].charges = response.data.charges;
          }
        })
        .catch(error => {
          this.$alertMsg(error.response.data);
        });
    },
    modeifyNote() {
      this.$v.inputDetails.$touch();

      if (this.$v.inputDetails.$invalid) {
        return;
      }

      var parameter = {
        ApplicationId: this.appId,
        ApplicationKey: 0,
        Sequence: this.dataObj.appData.notes[this.selectedNoteIndex].sequence,
        InputDetails: {
          DocumentType: this.dataObj.appData.details[this.selectedNoteIndex].documentType,
          Code: this.dataObj.appData.details[this.selectedNoteIndex].code,
          SubCode: this.dataObj.appData.details[this.selectedNoteIndex].subCode,
          Selection: this.dataObj.appData.details[this.selectedNoteIndex].selection,
          IsOwner: this.dataObj.appData.details[this.selectedNoteIndex].isOwner,
          Ageing: this.dataObj.appData.details[this.selectedNoteIndex].ageing,
          CustomerKey: this.dataObj.appData.details[this.selectedNoteIndex].customerKey,
          CustomerName: this.dataObj.appData.details[this.selectedNoteIndex].customerName,
          EffectiveDate: moment(this.effectiveDate2, "DD/MM/YYYY").add(1, 'days'),
          Amount: this.inputDetails.amount,
          DiscountPercentage: this.dataObj.appData.details[this.selectedNoteIndex].discountVisible == true ? this.inputDetails.discountPercentage : 0,
          RDChequeDate: this.dataObj.appData.details[this.selectedNoteIndex].rdChequeVisible == true ? moment(this.rdChequeDate2, "DD/MM/YYYY").add(1, 'days') : null,
          RDChequeNumber: this.dataObj.appData.details[this.selectedNoteIndex].rdChequeNumber,
          Consumption: this.dataObj.appData.details[this.selectedNoteIndex].consumptionVisible == true ? this.dataObj.appData.details[this.selectedNoteIndex].consumption : 0,
          Description: this.dataObj.appData.notes[this.selectedNoteIndex].description
        },
        InstallmentsData: this.dataObj.appData.notes[this.selectedNoteIndex].hasInstallments ? {
          TotalAmount: Number(this.inputDetails.amount),
          InstallmentMethod: Number(this.dataObj.appData.installmentsData[this.selectedNoteIndex].installmentMethod),
          InstallmentAmount: Number(this.dataObj.appData.installmentsData[this.selectedNoteIndex].installmentAmount),
          NumberOfInstallments: Number(this.dataObj.appData.installmentsData[this.selectedNoteIndex].numberOfInstallments),
          InitialAmount: Number(this.dataObj.appData.installmentsData[this.selectedNoteIndex].initialAmount),
          ChargeSchedule: Number(this.dataObj.appData.installmentsData[this.selectedNoteIndex].chargeSchedule),
          ChargeMonth: Number(this.dataObj.appData.installmentsData[this.selectedNoteIndex].chargeMonth),
          ChargeDay: Number(this.dataObj.appData.installmentsData[this.selectedNoteIndex].chargeDay),
          HasInstallments: this.dataObj.appData.notes[this.selectedNoteIndex].hasInstallments,
        } : null
      };
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/IssueDebitCreditNoteActivity/ModifyNote', parameter)
        .then(response => {
          if (response.status == 200) {
            console.log(response);
            this.dataObj.appData = response.data.item;
            this.editNote = {};
            this.allowEdit = false;

            loader.hide();

            this.showNoteDialog = false;
          }
          else {
            loader.hide();
          }
        })
        .catch(error => {
          this.$alertMsg(error.response.data);
          loader.hide();
        });
    },
    removeNote() {
      var parameter = {
        ApplicationId: this.appId,
        ApplicationKey: 0,
        Sequence: this.dataObj.appData.notes[this.selectedNoteIndex].sequence
      };
      //let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/IssueDebitCreditNoteActivity/RemoveNote', parameter)
        .then(response => {
          if (response.status == 200) {
            this.selectedNoteIndex = 0;
            this.dataObj.appData = response.data.item;
            //loader.hide();
          }
          else {
            //loader.hide();
          }
        })
        .catch(error => {
          this.$alertMsg(error.response.data);
          //loader.hide();
        });
    },
    onSelectNote(item) {
      if (item == null)
        return;

      this.selectedNoteIndex = item.sequence - 1;
    },
    allowEditNote(index) {

      if (this.dataObj.readOnly)
        return;

      this.selectedNoteIndex = index;

      var d = Object.assign({}, this.dataObj.appData.details[this.selectedNoteIndex]);
      var n = Object.assign({}, this.dataObj.appData.notes[this.selectedNoteIndex]);

      this.editNote = {
        details: d,
        note: n
      }

      this.inputDetails.amount = this.dataObj.appData.details[this.selectedNoteIndex].amount;
      this.inputDetails.discountPercentage = this.dataObj.appData.details[this.selectedNoteIndex].discountPercentage;

      this.allowEdit = true;

      this.showNoteDialog = true;
    },
    deleteNote(index) {
      if (this.dataObj.readOnly)
        return;

      this.selectedNoteIndex = index;

      this.deleteConfirmMessage = 'Are you sure from remove this transaction (' + this.dataObj.appData.notes[this.selectedNoteIndex].finAppTypeDescription + ' ' + this.dataObj.appData.notes[this.selectedNoteIndex].typeDescription + ') ?';

      this.confirmRemoveNote = true;
    },
    cancelEdit() {
      this.dataObj.appData.details[this.selectedNoteIndex] = this.editNote.details;
      this.dataObj.appData.notes[this.selectedNoteIndex] = this.editNote.note;

      this.editNote = {};
      this.allowEdit = false;
      this.showNoteDialog = false;
    },
    fillInputDetails() {
      this.inputDetails = this.dataObj.appData.details[this.selectedNoteIndex];
    },
    changeDocType(val) {
      this.dataObj.appData.details[this.selectedNoteIndex].charge = this.charges.filter(a => a.documentType == val)[0].charges[0].value;
    },
    changeTab(e) {
      this.currentTab = e;
    },
    refreshInstallments() {
      var parameter = {
        TotalAmount: Number(this.inputDetails.amount),
        InstallmentMethod: Number(this.dataObj.appData.installmentsData[this.selectedNoteIndex].installmentMethod),
        InstallmentAmount: Number(this.dataObj.appData.installmentsData[this.selectedNoteIndex].installmentAmount),
        NumberOfInstallments: Number(this.dataObj.appData.installmentsData[this.selectedNoteIndex].numberOfInstallments),
        InitialAmount: Number(this.dataObj.appData.installmentsData[this.selectedNoteIndex].initialAmount),
        ChargeSchedule: Number(this.dataObj.appData.installmentsData[this.selectedNoteIndex].chargeSchedule),
        ChargeMonth: Number(this.dataObj.appData.installmentsData[this.selectedNoteIndex].chargeMonth),
        ChargeDay: Number(this.dataObj.appData.installmentsData[this.selectedNoteIndex].chargeDay),
        HasInstallments: this.dataObj.appData.installmentsData[this.selectedNoteIndex].hasInstallments,
      };

      this.$store.state.notifier.asyncBlock(
        axios.post('/IssueDebitCreditNoteActivity/RefreshInstallments', parameter),
        response => {
          console.log('IssueChargesActivity/RefreshInstallments', response.data);
          if (response.status == 200) {
            this.installmentDescribe = this.dataObj.appData.installmentsData[this.selectedNoteIndex].chargeSchedule == 1 ? 'cycleNo' : 'chargeDate';
            this.dataObj.appData.installmentsData[this.selectedNoteIndex].installments = response.data;
          }
          else
            this.$alertMsg(response.data.data.text)
        },
        err => {
          this.$alertMsg(err.data);
        }
      );
    }
  },
}
